/**
 * Fetches every page of a Strapi collection REST URL (urlBase must include
 * query string; pagination params are appended).
 */
export async function fetchAllStrapi(
  urlBase: string,
  apiKey: string
): Promise<any[]> {
  const headers = { Authorization: `Bearer ${apiKey}` }
  let page = 1
  const allItems: any[] = []

  while (true) {
    const url = `${urlBase}&pagination[page]=${page}`

    const res: any = await $fetch(url, { headers })
    const data: any[] = res && res.data ? res.data : []
    allItems.push(...data)

    const metaPagination =
      res && res.meta && res.meta.pagination ? res.meta.pagination : null

    let currentPage = page
    let pageCount = page
    if (metaPagination) {
      if (typeof metaPagination.page === 'number') {
        currentPage = metaPagination.page
      }
      if (typeof metaPagination.pageCount === 'number') {
        pageCount = metaPagination.pageCount
      }
    }

    if (currentPage >= pageCount || data.length === 0) break
    page += 1
  }
  return allItems
}
